export const MuiSwitch = {
  switchBase: {
    height: "auto",
    width: "auto"
  }
};
